export interface TargetDescription {
  name: string
  role: string
}

const TAG_ROLES: Record<string, string> = {
  button: 'button',
  a: 'link',
  select: 'combobox',
  textarea: 'textbox',
  summary: 'button',
  th: 'columnheader',
  td: 'cell',
  tr: 'row',
  h1: 'heading',
  h2: 'heading',
  h3: 'heading',
  h4: 'heading',
}

function roleOf(el: Element): string {
  const explicit = el.getAttribute('role')
  if (explicit) return explicit
  const tag = el.tagName.toLowerCase()
  if (tag === 'input') {
    const type = (el.getAttribute('type') ?? 'text').toLowerCase()
    if (type === 'checkbox') return 'checkbox'
    if (type === 'radio') return 'radio'
    if (type === 'button' || type === 'submit') return 'button'
    return 'textbox'
  }
  return TAG_ROLES[tag] ?? 'generic'
}

function fallbackName(el: Element, role: string): string {
  if (el.tagName.toLowerCase() === 'input') {
    const type = (el.getAttribute('type') ?? 'text').toLowerCase()
    if (type === 'password') return 'password field'
    if (role === 'textbox') return 'text field'
  }
  return role === 'generic' ? 'element' : role
}

/**
 * Names an element for the step log from an allowlist only: `data-sat-name`, then `data-testid`,
 * then its role. It never reads aria-label, title, text content or a value, because those can
 * carry a client name or typed data (EC22).
 */
export function describeTarget(start: Element): TargetDescription {
  let node: Element | null = start
  while (node) {
    const named = node.getAttribute('data-sat-name') ?? node.getAttribute('data-testid')
    if (named) return { name: named, role: roleOf(node) }
    const role = roleOf(node)
    if (role !== 'generic') return { name: fallbackName(node, role), role }
    node = node.parentElement
  }
  return { name: 'element', role: 'generic' }
}
